import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-justify" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle fa-xs" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkExperienceEntryHeader = _resolveComponent("WorkExperienceEntryHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WorkExperienceEntryHeader, {
      title: _ctx.title,
      companyName: _ctx.companyName,
      address: _ctx.address,
      duration: _ctx.duration
    }, null, 8, ["title", "companyName", "address", "duration"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "space-x-6",
        key: detail
      }, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(detail), 1)
      ]))
    }), 128)),
    _hoisted_3
  ]))
}